var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        persistent: "",
        centerScreen: "",
        centerAndDecreasesPadding: "",
        closeColor: "#8E8E8E",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u(
        [
          {
            key: "title",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "pl-5 pt-5 ml-5 d-flex align-center" },
                  [
                    _c("h1", { staticClass: "m-0 text-md font-regular" }, [
                      _vm._v(" " + _vm._s(_vm.title) + " ")
                    ])
                  ]
                )
              ]
            },
            proxy: true
          },
          _vm.cancelVisible
            ? {
                key: "actions",
                fn: function() {
                  return [
                    _c("v-spacer"),
                    _c(
                      "BaseButton",
                      {
                        attrs: { small: "", underlined: "" },
                        on: { click: _vm.stopRequest }
                      },
                      [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]
                    )
                  ]
                },
                proxy: true
              }
            : null
        ],
        null,
        true
      )
    },
    [
      _c("div", { staticClass: "pl-10 pr-10 mt-5" }, [
        _c("p", { staticClass: "font regular text-xs text-color-5e" }, [
          _vm._v(" " + _vm._s(_vm.description) + " ")
        ]),
        _c(
          "div",
          [
            _c("p", { staticClass: "font regular text-xs text-color-5e" }, [
              _vm._v(" " + _vm._s(_vm.progressText) + " ")
            ]),
            _vm._l(_vm.internalSteps, function(stepItem, i) {
              return _c(
                "div",
                { key: i, staticClass: "d-flex align-items-center mb-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "rounded-circular full-center",
                      staticStyle: {
                        width: "15px",
                        height: "15px",
                        position: "relative"
                      },
                      style: {
                        border:
                          !stepItem.loading && !stepItem.complete
                            ? "1px solid #8e8e8e"
                            : "none"
                      }
                    },
                    [
                      stepItem.complete
                        ? _c("icon-svg", {
                            staticStyle: { position: "absolute" },
                            attrs: {
                              name: "check-circle",
                              size: "17",
                              color: "#4CAF50"
                            }
                          })
                        : stepItem.loading
                        ? _c("base-loading", {
                            staticStyle: { position: "absolute" },
                            attrs: { loading: "", size: 15, minHeight: "15px" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "ml-2 text-xs font-regular text-dark" },
                    [
                      _vm._v(
                        " Etapa " +
                          _vm._s(stepItem.step) +
                          ": " +
                          _vm._s(stepItem.title) +
                          " "
                      )
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }